<script>
	import { onMount } from "svelte";
	export let kicker;
	export let heading;
	export let teaser;
	export let paywall;

	let h = 2000;

	let a1d;
	let a2d;
	let a1m;
	let a2m;
	let c;

	onMount(function () {
		if (paywall) return;

		let pos = 0;
		let targetPos = 0;

		h = window.innerHeight;

		const delta = 100 / h;

		function update() {
			c.style.opacity = Math.max(0, Math.min(1, 1.5 * 1.5 - 1.5 * pos));

			a1d.style.transform = `translate(0, -${1.5 * h * pos}px`;
			a1m.style.transform = `translate(0, -${1.5 * h * pos}px`;

			a2d.style.transform = `translate(0, ${0.85 * h * pos}px`;
			a2m.style.transform = `translate(0, ${0.85 * h * pos}px`;

			a2m.style.opacity = Math.max(0, 1 - pos * 1.9);
		}

		function loopLead() {
			const y = window.pageYOffset;
			targetPos = Math.min(1.5, y / h);
			if (pos !== targetPos) {
				if (Math.abs(pos - targetPos) < delta) {
					pos = targetPos;
				} else if (pos > targetPos) {
					pos -= delta;
				} else if (pos < targetPos) {
					pos += delta;
				}
				update();
			}
		}

		if (!window.extraLoopFunctions) window.extraLoopFunctions = [];
		window.extraLoopFunctions.push(loopLead);
	});
</script>

<div class="lead" class:paywall>
	<div class="lead-bg">
		<div class="lead-color" bind:this={c} />
		<div class="lead-desktop">
			<div
				class="lead-image-d"
				bind:this={a1d}
				style="background-image: url({PATH}images/intro_1.svg);"
			/>
			<div
				class="lead-image-d"
				bind:this={a2d}
				style="background-image: url({PATH}images/intro_2.svg);"
			/>
		</div>
		<div class="lead-mobile">
			<div
				class="lead-image-m"
				bind:this={a1m}
				style="background-image: url({PATH}images/intro_m_1.svg);"
			/>
			<div
				class="lead-image-m"
				bind:this={a2m}
				style="background-image: url({PATH}images/intro_m_2.svg);"
			/>
		</div>
	</div>

	<div class="lead-content" style="height: {1.5 * h}px">
		<div class="content">
			{#if kicker} <div class="kicker">{@html kicker}</div>{/if}
			{#if heading}
				<div class="heading">
					<span style="background-image: url({PATH}images/first-letter.png)">{@html heading}</span>
				</div>{/if}
			{#if teaser} <div class="teaser">{@html teaser}</div>{/if}
		</div>
	</div>
</div>

<style>
	.lead {
		margin-bottom: -60vh;
	}

	.lead-bg {
		position: fixed;
		z-index: 1;
		width: 100%;
		height: 100vh;
		pointer-events: none;
		overflow: hidden;
	}

	.paywall.lead {
		position: relative;
		width: 100%;
		height: 100vh;
	}
	.paywall .lead-bg {
		position: relative;
	}

	.paywall .lead-content {
		height: 100% !important;
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
	}

	.lead-color {
		background-color: #f7ca20;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 0;
		will-change: opacity;

		/*
    transition: opacity 0.1s;
    */
	}

	.lead-content {
		position: relative;
		z-index: 2;
		/*
       text-shadow: rgb(247, 202, 32) 4px 0px 0px, rgb(247, 202, 32) 3.87565px 0.989616px 0px, rgb(247, 202, 32) 3.51033px 1.9177px 0px, rgb(247, 202, 32) 2.92676px 2.72656px 0px, rgb(247, 202, 32) 2.16121px 3.36588px 0px, rgb(247, 202, 32) 1.26129px 3.79594px 0px, rgb(247, 202, 32) 0.282949px 3.98998px 0px, rgb(247, 202, 32) -0.712984px 3.93594px 0px, rgb(247, 202, 32) -1.66459px 3.63719px 0px, rgb(247, 202, 32) -2.51269px 3.11229px 0px, rgb(247, 202, 32) -3.20457px 2.39389px 0px, rgb(247, 202, 32) -3.69721px 1.52664px 0px, rgb(247, 202, 32) -3.95997px 0.56448px 0px, rgb(247, 202, 32) -3.97652px -0.432781px 0px, rgb(247, 202, 32) -3.74583px -1.40313px 0px, rgb(247, 202, 32) -3.28224px -2.28625px 0px, rgb(247, 202, 32) -2.61457px -3.02721px 0px, rgb(247, 202, 32) -1.78435px -3.57996px 0px, rgb(247, 202, 32) -0.843183px -3.91012px 0px, rgb(247, 202, 32) 0.150409px -3.99717px 0px, rgb(247, 202, 32) 1.13465px -3.8357px 0px, rgb(247, 202, 32) 2.04834px -3.43574px 0px, rgb(247, 202, 32) 2.83468px -2.82216px 0px, rgb(247, 202, 32) 3.44477px -2.03312px 0px, rgb(247, 202, 32) 3.84068px -1.11766px 0px, rgb(247, 202, 32) 3.9978px -0.132717px 0px;
       */
	}

	.lead-image-d {
		position: absolute;
		z-index: 0;
		width: calc(100% - 40px);
		max-width: 1040px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin-left: auto;
		margin-right: auto;
		background-size: 100%;
		background-position: top center;
		background-repeat: no-repeat;
		will-change: transform;

		/*
    transition: transform 0.1s;
    */
	}

	.lead-image-m {
		position: absolute;
		z-index: 0;
		max-width: 1040px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin-left: auto;
		margin-right: auto;
		background-repeat: no-repeat;
		background-size: 68%;
		background-position: 100% 40px;
		will-change: transform;

		/*
    transition: transform 0.1s;
    */
	}

	.lead-desktop {
		display: block;
	}
	.lead-mobile {
		display: none;
	}

	@media (max-width: 580px) {
		.lead-desktop {
			display: none;
		}
		.lead-mobile {
			display: block;
		}
	}

	.content {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		left: 0;
		right: 0;
		top: 80vh;
		padding: 30px 0;
		transform: translateY(calc(-100% + 30px));
		width: 535px;
		font-family: "Abril Text", Georgia, Times, serif;
		font-size: 20px;
		line-height: 28px;
		text-rendering: optimizeLegibility;
		/*background-image: linear-gradient(to bottom, rgba(247, 202, 32, 0) 0, rgba(247, 202, 32, 7) 30px, rgba(247, 202, 32, 0.7) calc(100% - 30px), rgba(247, 202, 32, 0) 100%);*/
	}

	@media (max-width: 1200px) {
		.content {
		}
	}

	@media (max-width: 980px) {
		.content {
			top: 88vh;
		}
	}

	@media (max-width: 980px) and (orientation: portrait) {
		.content {
			top: 81vh;
		}
	}

	@media (max-width: 800px) {
		.content {
			right: 0;
			max-width: 420px;
		}
	}

	@media (max-width: 580px) {
		.content {
			top: calc(110vw);
			transform: none;
			width: 100%;
			text-align: center;
		}
	}

	.kicker {
		color: #cd0100;
		font-weight: 600;
		font-size: 24px;
		line-height: 38px;
	}

	.heading {
		font-weight: 700;
		font-size: 52px;
		line-height: 62px;
		margin-bottom: 10px;
		position: relative;
	}

	.heading span {
		background-repeat: no-repeat;
		background-position: 8px 54px;
		background-size: 20px;
	}

	@media (max-width: 480px) {
		.heading span {
			background-position: 3px 25px;
			background-size: 11px;
		}
	}
	.teaser {
		font-weight: 400;
		font-size: 20px;
		line-height: 32px;
	}

	@media (max-width: 480px) {
		.kicker {
			font-size: 16px;
			line-height: 26px;
		}

		.heading {
			font-size: 24px;
			line-height: 32px;
		}

		.teaser {
			font-weight: 400;
			font-size: 16px;
			line-height: 26px;
		}
	}
</style>
